import apiClient from '../apiClient';
import { GET_RESTAURANT_PROFILE_EXPORT_DATA_URL } from '../apiUrl';

const getExportRestaurantProfileApi = () => {
  return apiClient.get(GET_RESTAURANT_PROFILE_EXPORT_DATA_URL);
};

export default getExportRestaurantProfileApi;
